import { InviteRead, Role } from '@/api/dashboard'
import EditInviteDialog from '@/layouts/users/components/EditInviteDialog'
import { cn, useIsMobile, useModal } from '@dashboard/ui'
import { useTranslation } from 'react-i18next'

interface InviteUserBlockProps {
  onClick?: () => void
}

export const InviteUserBlock = ({ onClick }: InviteUserBlockProps) => {
  const openInviteModal = useModal<{ item: InviteRead }>(props => <EditInviteDialog {...props} />)
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  return (
    <div
      className={cn('cursor-pointer', isMobile ? '' : 'px-4')}
      data-testid="header/invite-to-team"
      onClick={() => {
        openInviteModal({ item: { role: Role.User } as InviteRead })
        onClick && onClick()
      }}
    >
      {t('header.invite-friend')}
    </div>
  )
}
